import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

// @ts-ignore
import DeleteDataModal from './DeleteDataModal';

import DefaultUserImage from 'assets/images/users/user-dummy-img.jpg';
import useGetUser from 'hooks/VisitReport/useGetUser';
import SignatureModal from 'components/SignatureModal/SignatureModal';
import UpdateMyProfileModal from 'components/UpdateMyProfileModal/UpdateMyProfileModal';
import { useUpdateMyProfileModalStore } from 'components/UpdateMyProfileModal/UpdateMyProfileModalStore';
import { User } from 'api/profile/type';

const ProfileDropdown = () => {
  const { data: userData, refetch } = useGetUser();

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { onUpdateMyProfileModalOpen } = useUpdateMyProfileModalStore();

  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <React.Fragment>
      <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item">
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={userData?.avatar ? `${process.env.REACT_APP_BASE_DJANGO_URL}${userData?.avatar}` : DefaultUserImage}
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {userData?.first_name ? userData?.first_name : userData?.email}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">{userData?.first_name ? userData?.first_name : userData?.email}</h6>
          <DropdownItem className="p-0">
            <div className="dropdown-item" onClick={() => onUpdateMyProfileModalOpen(userData as User)}>
              <i className="ri-user-settings-fill text-muted fs-16 align-middle me-1" />
              <span className="align-middle">Edit My Profile</span>
            </div>
          </DropdownItem>
          <div className="dropdown-divider" />
          <DropdownItem className="p-0">
            <Link to={`${process.env.REACT_APP_BASE_DJANGO_URL}/password_reset/`} className="dropdown-item">
              <i className="mdi mdi-key text-muted fs-16 align-middle me-1" />{' '}
              <span className="align-middle">Change password</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <div className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => setIsDeleteModalOpen(true)}>
              <i className="mdi mdi-trash-can-outline text-muted fs-16 align-middle me-1" />{' '}
              <span className="align-middle">Delete My Data</span>
            </div>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to="/logout/" className="dropdown-item">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />{' '}
              <span className="align-middle" data-key="t-logout">
                Logout
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
        <SignatureModal refetch={() => ''} />
        <UpdateMyProfileModal refetch={refetch} />
      </Dropdown>
      <DeleteDataModal isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)} />
    </React.Fragment>
  );
};

export default ProfileDropdown;
